import { useCallback, useEffect, useState } from "react";
import { AccountDepositDefinition } from "../../../models/AccountDepositDefinition";
import { GET_DEPOSIT_DEFINITION } from "../../../api/apiRoutes";
import { setActiveStep } from "../../../store/basket/basketActions";
import { useDispatch } from "react-redux";
import useApiRequest from "../../../utils/hook/useApiRequest";

export default function useAccountDefinition() {
  const [loading, setLoading] = useState(false);
  const [accountDepositDef, setAccountDepositDef] = useState<AccountDepositDefinition[]>([]);
  const [selectAccDepositDef, setSelectAccDepositDef] = useState<AccountDepositDefinition | null>(null);
  const dispatch = useDispatch();
  const { get } = useApiRequest();

  const handleGetExercises = useCallback(async () => {
    setLoading(true);
    const { isError, result } = await get(GET_DEPOSIT_DEFINITION);
    if (!isError) {
      setAccountDepositDef(result);
    }
    setLoading(false);
  }, [get]);

  useEffect(
    () => {
      handleGetExercises();
      dispatch(setActiveStep(0));
    }, // eslint-disable-next-line
    [handleGetExercises]
  );

  return {
    loading,
    accountDepositDef,
    selectAccDepositDef,
    setSelectAccDepositDef,
  };
}
